import {Point, FeatureCollection} from "geojson"
import {Feature} from "ol"
import {GeoJSON} from "ol/format"
import {Point as OLPoint} from "ol/geom"
import {TBuoyProps} from "@ui/api/features"
import popupService from "./PopupService"
import {LayerId} from "./"
import FeatureService from "./FeatureService"

export interface IBuoyService {
  addBuoys<T extends TBuoyProps>(buoys: FeatureCollection<Point, T>, layerId: LayerId): void
  toggleLayer(isVisible: boolean): void
}

export class BuoyService extends FeatureService implements IBuoyService {
  buoyLayers = [LayerId.BOYLAT, LayerId.BOYSAW, LayerId.BOYSPP]

  private constructBuoyPopup(feature: Feature<OLPoint>) {
    const featureProps = feature.getProperties()
    return FeatureService.constructFeaturePopup([
      {
        name: "buoy",
        obj: featureProps,
        propNames: [
          "mark_type",
          "buoy_shape",
          "lateral_mark_category",
          {name: "obj_name", hasNational: true, isDictionary: true},
          {name: "information", hasNational: true, isDictionary: true}
        ]
      },
      {
        name: "lights",
        obj: featureProps.lights,
        propNames: [
          "colour",
          "light_type",
          {name:"signal_group", isData: true},
          {name:"signal_period", isData: true}
        ]
      }
    ])
  }

  addBuoys<T extends TBuoyProps>(buoys: FeatureCollection<Point, T>, layerId: LayerId): void {
    const formatter = new GeoJSON()
    let features = formatter.readFeatures(buoys) as Feature<OLPoint>[]
    if (features.length > 0) {
      features = features.map(feature => {
        feature.set("onClick", () => {
          popupService.showPopup(
            feature,
            this.constructBuoyPopup(feature),
            () => feature.setProperties({selected: false})
          )
          feature.setProperties({selected: true})
        })
        return feature
      })
      FeatureService.addFeatures(layerId, features)
    }
  }

  toggleLayer(isVisible: boolean) {
    this.buoyLayers.forEach(layerId => FeatureService.getLayer(layerId)?.setVisible(isVisible))
  }
}

export default new BuoyService() as IBuoyService
